import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'antd/dist/reset.css';
import './ImageModal.scss';
import { Modal } from 'antd';
import EditableInput from 'Components/forms/EditableInput';
import ZoomInIcon from 'Components/icons/ZoomInIcon';
import { ImageToolkit } from '../ImageToolkit/ImageToolkit';
import { openDocumentInNewTab } from 'Utils/appendImageUtil.js';
import { connect } from 'react-redux';

import fileSaver from 'file-saver';
import { apiDownloadDocument } from 'Apis/imageReaderApi';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';


class ImageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canvasSelectedIndex: 0,
      updatedPageList: [],
      downloadInProgress: false,
    };
    this.attachBindings();
  }

  attachBindings() {
    this.openDocument = this.openDocument.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.updatePageList = this.updatePageList.bind(this);
  }
  componentDidMount() {
    let updatedPageList = [];
    this.props.imageContents.forEach((image, imageIndex) => {
      updatedPageList = updatedPageList.concat({ pageId: imageIndex, pageContent: image });
    })
    this.setState({
      canvasSelectedIndex: this.props.canvasSelectedIndex,
      updatedPageList,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      canvasSelectedIndex: nextProps.canvasSelectedIndex,
    });
  }

  updatePageList(pageList) {
    this.setState({
      updatedPageList: pageList,
    })
    this.props.updatePageList(pageList);
  }

  openDocument() {
    let tabTitle = this.props.caseNumber ? `${this.props.caseNumber} : ${this.props.title}` : this.props.title;
    openDocumentInNewTab(this.state.updatedPageList, tabTitle);
  }


  downloadDocument() {
    this.setState({
      downloadInProgress: true,
    }, () => {
      let tiffTitle = this.props.title!==undefined && this.props.title.substr(0,this.props.title.lastIndexOf(".")) + ".tiff";
      return apiDownloadDocument(this.state.updatedPageList, tiffTitle)
        .then(response => {
          const blob = new Blob([response], { type: 'application/octet-stream' });
          fileSaver.saveAs(blob,tiffTitle);
          this.setState({
            downloadInProgress: false,
          });
        })
        .catch(error => {
          console.log('Unable to download the file: ', error);

          const notificationMessageError = {
            type: 'error',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: <div style={{ color: 'black', paddingTop: 10 }}>
              <b>System Error</b>: Unable to download selected document.
              </div>
          };
          openNotificationToast(notificationMessageError);
          this.setState({
            downloadInProgress: false,
          });
        });
    })
  }


  render() {
    return (
      <div>
        <Modal
          title={(
            <EditableInput
              extraClass="report-builder"
              label="Case Document"
              content={this.props.title}
              placeholder="Case Document"
              readOnly
              openDocument={this.openDocument}
              downloadDocument={this.downloadDocument}
              downloadInProgress={this.state.downloadInProgress}
              parsedPermissions={this.props.user.parsedPermissions}
            />
          )}
          icon={<ZoomInIcon />}
          visible={this.props.visible}
          okButtonProps={this.props.okButtonProps}
          cancelButtonProps={this.props.cancelButtonProps}
          onCancel={this.props.onCancel}
          width={this.props.width}
          wrapClassName={this.props.wrapClassName}
          style={{ top: 25 }}
        >
          <ImageToolkit
            updateParentSelectedPages={this.props.updateParentSelectedPages}
            imageContents={this.props.imageContents}
            imageContentsErr={this.props.imageContentsErr}
            updateFlag={this.props.updateFlag}
            addClass={this.props.addClass}
            updatePageSelectionIndex={this.props.updatePageSelectionIndex}
            canvasSelectedIndex={this.state.canvasSelectedIndex}
            imageCheckBoxRequired={this.props.imageCheckBoxRequired}
            zoomStyle={this.props.zoomStyle}
            selectedPages={this.props.selectedPages && this.props.selectedPages.filter(page => (page.isSelected === true))}
            selectAllFlag={this.props.selectAllFlag}
            updatePageList={this.updatePageList}
            pageselectormodal='pageselectormodal'
            isModal={true}
            user={this.props.user}
            documentTypeNames={this.props.documentTypeNames}
            pageList={this.props.pageList}
            acquirerCode={this.props.acquirerCode}
          />
        </Modal>
      </div>
    );
  }
}

ImageModal.propTypes = {
  title: PropTypes.string,
  caseNumber: PropTypes.string,
};

ImageModal.defaultProps = {
  title: '',
  caseNumber: '',
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ImageModal);
